module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Option/images/duration.ed3d7ef9.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Option/images/duration.png
// module id = 2519
// module chunks = 11